export const data = [
  {
    id: "lvxfdUlN7nZnwdYEaKLN",
    date: "2024-06-02T02:40:24.754Z",
    password: "",
    title: "웃는게 예쁜 우리 유정이🤍 결혼 너무 축하해🤍 \n웃음이 넘치는 행복한 결혼생활 하길 바라🤍  \n너무 예쁘다 축하해 🤍🤍🤍🤍",
    author: "황지형",
  },
  {
    id: "oQG1WCuXVFd8AqITDvBL",
    author: "장진규",
    date: "2024-05-27T14:04:34.578Z",
    password: "",
    title: "종범아 결혼 진심으로 축하하고 앞으로 꽃길만 걷자\n",
  },
  {
    id: "V6KGf2IwnfbnqrT0yNkb",
    date: "2024-05-26T23:53:18.328Z",
    author: "오세준",
    password: "545454",
    title: "유정아\n이 결혼으로 인해 행복한 인생이 되길 바랄게",
  },
  {
    id: "1TQxGfRdxzxujauHKpgP",
    password: "1234",
    title: "종범아 결혼 진심으로 축하한당. \n앞으로 좋은일만 가득하길~",
    author: "민석",
    date: "2024-05-17T08:31:46.706Z",
  },
  {
    id: "GtQCbtI6zJjfp1OQLNnj",
    date: "2024-05-08T05:58:25.070Z",
    author: "이해정",
    title: "우리 요정여신 구너~ 축하해 행복해야해 !! ㅎㅎ ",
    password: "Ps3174304!",
  },
  {
    id: "CnediVvencoJVpSkcXia",
    date: "2024-05-07T09:14:09.229Z",
    password: "7506",
    title: "유정아 행님이랑 평생 행복하게 살자잇! 결혼 축하한다👍",
    author: "유종민",
  },
  {
    id: "IfNpZkODJsdloZ8dXnPV",
    title: "구너 축하한다 행복하개 잘살아라~~😊",
    author: "권영호",
    password: "1245",
    date: "2024-05-07T07:54:51.502Z",
  },
  {
    id: "LjRvivEvGCb2x7rlloxv",
    password: "0210",
    date: "2024-05-07T07:26:11.921Z",
    author: "예린",
    title: "구너야아 축하해💓💓\n평생 행보캐",
  },
  {
    id: "B1boREToBlFOAxxLFcOQ",
    date: "2024-05-06T03:03:39.073Z",
    password: "12345",
    author: "박창준",
    title: "결혼축하해! 두사람 평생 행복하길~~.~",
  },
  { id: "3AVM4QAN2wKIdFpOlJ8a", date: "2024-05-05T03:21:00.027Z", author: "히딩크", password: "", title: "결혼을 축하합니다." },
  {
    id: "6iTBjuqCNOlN8Vld8bIJ",
    title: "종범아 너무너무 축하해!!!항ㅅ🫶🫶항상\n와이프분 너무 미인이시다아!!\n매일매일 햄볶으면서 살앙~\n그리",
    date: "2024-05-05T00:57:17.732Z",
    password: "",
    author: "다애누나",
  },
  {
    id: "Bm8Nrcj8vRjDVqSEnHs7",
    title: "두 분의 행복한 결혼 생활을 소망합니다 ☺️",
    date: "2024-05-04T16:34:19.097Z",
    author: "조주영",
    password: "",
  },
  {
    id: "WmeqsRd53D0jvJMRvhDI",
    author: "서강준",
    title: "유정씨 맘에 불을꺼줄 “소”방관 출동합니다.\n결혼 축하해요!",
    password: "",
    date: "2024-05-04T16:13:55.232Z",
  },
  {
    id: "SLYeO8dlHejTnv4zSkES",
    title: "제 친한 동생 종범이의 결혼생활을 진심으로 응원합니다!",
    password: "12341234",
    author: "류준열",
    date: "2024-05-04T13:00:14.962Z",
  },
  {
    id: "74GluqhzY1eUqFWTTEzP",
    title: "아름다운 두 분 평생 행복하세요. - 배우 송강-",
    password: "qwertyu",
    date: "2024-05-04T12:59:38.909Z",
    author: "송강",
  },
  { id: "lerdxdIhVDmaV6e6xfdy", date: "2024-05-04T12:59:07.652Z", author: "김환이", title: "정말 축하드립미다", password: "1234" },
  {
    id: "qA70gMV6rDIbGAqk1B9c",
    date: "2024-05-04T12:41:34.099Z",
    author: "남주혁",
    password: "0456",
    title: "바람에 흔들리지 않는 단단한 결혼 생활이 되기를!!!☺️\n축하드립니다. \n-배우 남주혁-",
  },
  {
    id: "hWwnB9ci7JnT9DwdNPtn",
    password: "wldbs8956",
    date: "2024-05-04T07:52:26.915Z",
    author: "Jy",
    title: "너무 이쁜 유정이 결혼 축하해♥️",
  },
  {
    id: "KKMM5TONTyyHkQhLAirr",
    author: "져니",
    date: "2024-05-02T11:50:00.723Z",
    password: "1234",
    title: "꺅 넘 잘어울려용 늘 예쁜 마음으로 행복하게 살길 🩷",
  },
  { id: "J5RuhVCu8Apmmshyz9Xo", title: "신랑 복받았다 ~..~", password: "", date: "2024-05-02T08:44:08.027Z", author: "김수빈" },
  {
    id: "hNzMthx8XSswoUlwDTfu",
    password: "",
    title: "유정이 너무 너무 축하해 행복하게 잘살아 ㅠ-ㅠ",
    author: "기염둥이",
    date: "2024-05-02T07:05:52.246Z",
  },
  {
    id: "XrzpqukHaumScENRjfYC",
    date: "2024-05-02T04:01:28.123Z",
    password: "",
    author: "이두식",
    title: "청솔로vip 고객님의 결혼을 축하드립니다.왈왈",
  },
  { id: "YAIbUG0X47o1rLSpTOUt", author: "소", date: "2024-04-21T12:53:37.470Z", password: "7540", title: "우리가족이 된 걸 환영해 😃" },
  { id: "ew9pzsAK5FoVfg0aH1GN", author: "채영", title: "항상 행복한 결혼 생활하기~", date: "2024-04-10T04:33:51.840Z", password: "7589" },
];
